// extracted by mini-css-extract-plugin
module.exports = {"brandLogo":"CI"};